module.exports = __webpack_public_path__ + "static/media/twitter-pink-on-white.746101e1.svg";